// src/services/students.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const studentsApi = createApi({
  reducerPath: "studentsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/students`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Students"],
  endpoints: (builder) => ({
    getStudentAwardsStatus: builder.query({
      query: () => "/",
      providesTags: ["Students"],
    }),
    claimAward: builder.mutation({
      query: ({ awardId, documentLink, files }) => {
        const formData = new FormData();
        if (documentLink) formData.append("documentLink", documentLink);

        if (files && files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
          }
        }

        return {
          url: `/claim/${awardId}`,
          method: "PUT",
          body: formData,
        };
      },
    }),
    deleteFile: builder.mutation({
      query: (id) => ({
        url: `/delete-file/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [{ type: "AdminAwards", id }],
    }),
    viewFile: builder.query({
      query: (id) => ({
        url: `/view-file/${id}`,
        method: "GET",
      }),
    }),
    downloadFile: builder.query({
      query: (id) => ({
        url: `/download-file/${id}`,
        method: "GET",
      }),
    }),
    updateStudentEmail: builder.mutation({
      query: ({ email }) => ({
        url: `/email`,
        method: "PUT",
        body: { email },
      }),
    }),
  }),
});

export const {
  useGetStudentAwardsStatusQuery,
  useUpdateStudentEmailMutation,
  useClaimAwardMutation,
  useDeleteFileMutation,
  useDownloadFileQuery,
  useLazyDownloadFileQuery,
  useViewFileQuery,
  useLazyViewFileQuery,
} = studentsApi;

export default studentsApi;
export { studentsApi };
